import { useContext, useCallback } from 'react';

import { diaryContext } from '../contexts/diaryContext';
import useFetch from './useFetch';

import diary from '../api/diary';

function useDiaryData() {
	const { data, selectedDate, period, handleChange, handleManualFetch, ...others } = useContext(diaryContext);
	// eslint-disable-next-line
	const [res, status] = useFetch(diary.getDiary);

	const handleSetSelectedDate = useCallback((selectedDate) => {
		handleChange({ selectedDate });
	}, [handleChange]);

	const diaryData = {
		data,
		selectedDate,
		period,
		...others
	};

	return [diaryData, status, handleSetSelectedDate, handleManualFetch];
}

export default useDiaryData;
